import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitContactRequest = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}/contact`, payload);
  return response.data;
};
